import React, { useRef, useEffect, useCallback, useState} from 'react';
import {usePreventDragging} from "components/effects/preventDragging.js"
import ParameterMod from 'components/effects/ParameterMod';
import ModEdges from './ModEdges.js';
import {LFO, ENVELOPE} from 'constants/mod-types.js';
import ModulatorNode from './ModulatorNode.js';
import {connect} from 'react-redux';

const ModRoutes = ({effect, sequencerEngine, parameters, width=260, height=40, color}) => { 
    let [lineDragging, setLineDragging] = useState(undefined);
    let [selectedEdge, setSelectedEdge] = useState(undefined);

    let ref = useRef(undefined);

    let {preventDragging} = usePreventDragging({ref, effect});

    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [selectedEdge, setSelectedEdge]);

    const onKeyDown = useCallback((e) => {
        if (e.target.tagName === 'INPUT') {
            return;
        }

        if (e.key === 'Backspace') {
            if (selectedEdge) {
                let {modulator, parameter} = selectedEdge;
                if (modulator.getType() === LFO) {
                    parameter.disconnectFromLFO(modulator);
                } else {
                    parameter.disconnectFromEnvelope(modulator);
                }
                setSelectedEdge(undefined);
            }
        }
    }, [selectedEdge, setSelectedEdge]);

    const onModulatorMouseUp = useCallback((e, param) => {
        if (lineDragging && param) {
            let {modulator} = lineDragging;
            if (!param.isAudioParamEnabled()) {
                param.enableAudioParam();
            }

            if (modulator.getType() === LFO) {
                param.connectToLFO(modulator);
            } else {
                param.connectToEnvelope(modulator);
            }
        }
    }, [lineDragging, setLineDragging]);

    const onMouseMove = useCallback((e) => {
        if (lineDragging) {
            let rect = ref.current.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            let _line = {
                ... lineDragging,
                x2: x,
                y2: y
            };
            setLineDragging(_line);
        }
    }, [lineDragging, setLineDragging]);

    const getXForParameter = (param) => {
        let index = parameters.indexOf(param);
        return 25 + index * 48;
    };

    const onParameterMouseDown = useCallback((e, parameter) => {
        let rect = ref.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        
        setLineDragging({x1: x, y1: y, x2: x, y2: y, parameter});
    }, [setLineDragging, ref]);

    let modulators = [... sequencerEngine.lfos.map(x => x.lfo), ... sequencerEngine.envelopes];
    return (
        <div
          ref={ref}
          className="mod-routes">
          <svg
            onMouseDown={() => {
                preventDragging(false);
                setSelectedEdge(undefined);
            }}
            onMouseUp={() => {
                preventDragging(true);
                setLineDragging(undefined);
            }}
            onMouseMove={onMouseMove}
            height={height} width={width}>
            {lineDragging ?
             <line
               x1={lineDragging.x1}
               y1={lineDragging.y1}
               x2={lineDragging.x2}
               y2={lineDragging.y2}
               stroke="red"
               strokeWidth={1}
             /> : []}
            {parameters.map(
                (param, i) =>
                    <g
                      key={"fuck-yeah-" + i}
                    >
                      <circle
                        key={"circle-yeah-" + i}
                        onMouseDown={(e) => onParameterMouseDown(e, param)}
                        onMouseUp={(e) => onModulatorMouseUp(e, param)}
                        cx={getXForParameter(param)} cy={2} r={3} fill="black"/>
                      <ModEdges
                        key={i}
                        selectedEdge={selectedEdge}
                        setSelectedEdge={setSelectedEdge}
                        i={i}
                        color={color}
                        parameter={param}
                        height={height}/>
                    </g>
            )}
            {modulators.map(
                (x, i) =>
                    <ModulatorNode
                      key={i}
                      el={ref}
                      setLineDragging={setLineDragging}
                      lineDragging={lineDragging}
                      i={i}
                      width={width}
                      height={height}
                      modulator={x}/>)}
          </svg>
        {selectedEdge ?
         <ParameterMod
           parameterMod={
               selectedEdge.parameter.parameterMods
                   .find(m => m.modulator === selectedEdge.modulator)}
         /> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModRoutes);
